export const addresses = {
  alphatoken:"0x8256C34EA02bb0C2Cdd18AeB3d440b46DeaD302f"
}
